import { Link } from "react-router-dom";
import { Server, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-secondary text-secondary-foreground" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl font-bold text-red-500">Power<span className="text-white">Hosting</span></span>
            </div>
            <p className="text-secondary-foreground/80 mb-4">
              شريكك الموثوق في عالم الاستضافة والتصميم والتسويق الرقمي في العالم
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">روابط سريعة</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                  الرئيسية
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                  من نحن
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                  تواصل معنا
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-secondary-foreground/80 hover:text-primary transition-colors">
                  تسجيل الدخول
                </Link>
              </li>
            
                </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">خدماتنا</h3>
            <ul className="space-y-2">
              <li>
                <span className="text-secondary-foreground/80">استضافة مواقع</span>
              </li>
              <li>
                <span className="text-secondary-foreground/80">تصميم مواقع</span>
              </li>
              <li>
                <span className="text-secondary-foreground/80">تسويق رقمي</span>
              </li>
              <li>
                <span className="text-secondary-foreground/80">دعم فني 24/7</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">تواصل معنا</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary" />
                <span className="text-secondary-foreground/80">support@hosting-power.com</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary" />
                <span className="text-secondary-foreground/80 font-mono" dir="ltr">+20 11 42796664</span>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-5 h-5 text-primary" />
                <span className="text-secondary-foreground/80">القاهرة، مصر</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal links */}
      <nav aria-label="Legal" className="border-t border-secondary-foreground/10 mt-8 pt-6">
        <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
          <li><Link to="/privacy-policy" className="text-secondary-foreground/80 hover:text-primary transition-colors">Privacy Policy</Link></li>
          <li><Link to="/refund-policy" className="text-secondary-foreground/80 hover:text-primary transition-colors">Refund Policy</Link></li>
          <li><Link to="/terms-and-conditions" className="text-secondary-foreground/80 hover:text-primary transition-colors">Terms and Conditions</Link></li>
        </ul>
      </nav>

      {/* Bottom */}
        <div className="mt-6 text-center">
          <p className="text-secondary-foreground/60">
            © {new Date().getFullYear()} Power Hosting. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
